module.exports = __webpack_public_path__ + "static/media/now-by-ekko.6d52ad85.png";